import React from "react";
import Navbar from "./Navbar";
import dev from "../assets/download.png";
import { ArrowBack } from "@mui/icons-material";
import { Link } from "react-router-dom";

const Developers = ({ themeClass }) => {
  return (
    <div className={`${themeClass} min-h-screen w-screen overflow-y-auto overflow-x-hidden`}>
      <Link to={'/'} className="fixed bottom-4 left-4 z-50">
        <div className="rpg-btn" style={{width: '50px', background: '#b91c1c'}}>
            <ArrowBack fontSize="large"/>
        </div>
      </Link>
      
      <Navbar />
      
      <div className="flex items-center justify-center flex-col gap-6 text-white mb-8 mt-10">
        <div className="rpg-panel flex flex-col items-center p-8">
            <div className="border-4 border-white mb-6 bg-black p-2">
                 <img src={dev} className="h-[200px] pixelated" alt="dev icon" />
            </div>
            
            <div className="w-full text-center space-y-8">
                <div>
                    <h1 className="text-2xl text-[#fbfaaa] mb-1">LD FIRE STARTER</h1>
                    <p className="text-sm text-gray-400 font-[VT323] text-xl">Founder & Lead Developer</p>
                </div>
                
                <div className="border-t border-gray-800 pt-4">
                    <h1 className="text-xl text-[#00d9ff] mb-1">NA HEX</h1>
                    <p className="text-sm text-gray-400 font-[VT323] text-xl">Helper & QA Tester</p>
                </div>
                
                <div className="border-t border-gray-800 pt-4">
                    <h1 className="text-xl text-[#ff0000] mb-1">THE END SICKO</h1>
                    <p className="text-sm text-gray-400 font-[VT323] text-xl">Map Designer & Strategist</p>
                </div>
            </div>
        </div>
      </div>
    </div>
  );
};

export default Developers;